export default {
  menu: 'Internal Transfer',
  title: 'Internal Transfer',

  general: {
    types: {
      cash: 'Cash',
      bank: 'Bank',
      user: 'User',
      storeroom: 'Store',
      paymentGateway: 'Payment Gateway'
    },

    labels: {
      sourceType: 'Receive from',
      source: '{type} source',
      destinationType: 'deposit to',
      destination: '{type} Destination',
      price: 'Amount',
      date: 'Transfer date',
      bankBalance: 'Bank balance',
      cashBoxBalance: 'Funds',
      hasWage: 'Fee',
      wage: 'Fee deduction',
      totalPriceWithWage: 'Total Price',
      referenceId: 'Tracking number',
      description: 'Description'
    },

    placeholder: {
      date: 'Automatic'
    },

    table: {
      header: {
        restore: 'Restore',
        delete: 'Delete',
        price: 'Amount',
        description: 'Documents',
        payee: 'Payee',
        payer: 'Payer',
        creator: 'Creator',
        date: 'Date',
        referenceId: 'Reference id',
        docNumber: 'Document number',
        row: 'Row'
      }
    },

    notifications: {
      invalidPrice: 'Amount is not valid',
      invalidSourceType: 'Source type not selected',
      invalidSource: 'Source not selected',
      invalidDestinationType: 'Destination type not selected',
      invalidDestination: 'Destination not selected',
      equalSourceAndDestination: 'source and destination cannot be the same',
      lowBalance: 'The balance of the bank or fund is not enough',
      lowBalanceDynamicDate: 'The balance of the bank or fund in selected date is not enough!',
      incorrect_reference_id: 'reference id is not correct',

      insert: {
        success: 'Internal transfer successfully created',
        error: 'The creation of an internal transfer was accompanied by an error'
      },
      delete: {
        success: 'Internal transfer information successfully deleted',
        error: 'Deleting Internal Transfer Information Caused an Error'
      },
      restore: {
        success: 'Internal transfer information successfully restored',
        error: 'Restore the internal transfer information was accompanied by an error'
      },
      print: {
        success: 'Your request has been sent, please wait',
        error: 'The print request has error'
      }
    },

    confirmations: {
      delete: {
        title: 'Confirm Delete treasury transfer',
        body: 'Are you sure you want to delete this internal transfer completely?'
      }
    },

    validators: {
      dateHelp: 'The entry must be entered as {date}.',
      date: 'The transfer date is not entered correctly!',
      future: 'It is not possible to register a transfer for the future'
    }
  },

  insert: {
    title: 'New Treasury Transfer'
  },

  list: {
    title: 'Internal Transfer'
  },

  trash: {
    title: 'Removed Internal Transfer List'
  },

  document: {
    title: 'Internal Transfer',
    dynamicTitle: 'Internal Transfer No. {docNumber}',

    labels: {
      payer: 'Payer / payers',
      destinations: 'Recipient / recipients',
      details: 'Other information',
      referenceId: 'Reference id',
      creator: 'creator',
      date: 'Registration date',
      description: 'Description'
    }
  },

  logs: {
    title: 'Internal Transfer Logs'
  }
}
